module.exports = __webpack_public_path__ + "static/media/peru_mototurismo_1.378fbd96.jpg";